import { inject, Injectable, NgZone } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private readonly ngZone = inject(NgZone);
  private _loading = false;
  private activeRequests = 0;
  private readonly loadingStatusSubject$ = new BehaviorSubject<boolean>(false);
  public readonly loadingStatus$: Observable<boolean> =
    this.loadingStatusSubject$.asObservable();

  public get loading(): boolean {
    return this._loading;
  }

  public set loading(value: boolean) {
    if (this._loading === value) {
      return;
    }

    const applyValue = () => {
      this._loading = value;
      this.loadingStatusSubject$.next(value);
    };

    if (NgZone.isInAngularZone()) {
      applyValue();
      return;
    }

    this.ngZone.run(applyValue);
  }

  public startLoading(): void {
    this.activeRequests += 1;
    if (this.activeRequests === 1) {
      this.loading = true;
    }
  }

  public stopLoading(): void {
    this.activeRequests = Math.max(this.activeRequests - 1, 0);
    if (this.activeRequests === 0) {
      this.loading = false;
    }
  }
}
